import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
	root: {
		fontFamily: theme.fonts.bold,
		fontSize: "21px",
		lineHeight: "1.1",
		color: theme.palette.colors.purplishBlue,
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			fontSize: "16px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			marginTop: "5px",
			fontSize: "18px",
		},
	},
}));

const TariffName = ({ name }) => {
	const classes = useStyles();

	return (
		<div
			className={classes.root}
			dangerouslySetInnerHTML={{
				__html: name,
			}}
		/>
	);
};

export default TariffName;
